import { render, staticRenderFns } from "./BulkUpdate.vue?vue&type=template&id=01825983"
import script from "./BulkUpdate.vue?vue&type=script&lang=js"
export * from "./BulkUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports